import { render } from "./socialHeader.vue?vue&type=template&id=4c71ae74"
import script from "./socialHeader.vue?vue&type=script&lang=js"
export * from "./socialHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__